/* ==========================================================================
   StatusBar
   ========================================================================== */
//@import (reference) "../../../Base/01-settings/globals.less";
@import (reference) "./../../../../src/VX/Asset/Less/Base/01-settings/globals.less";
@import (reference) "./../../../../src/VX/Asset/Less/VX/02-tools/mixins";

.status-bar__wrapper {
  .mobile & {
    margin-top: 5px;
  }
}

.status-bar__container {
  margin-bottom: 10px;
  min-height: 66px;
  overflow: hidden;
  padding: 16px 20px;
  z-index: 4;

  &.-white {
    color: @color-bg;
    background-color: @color-mood-100;
  }

  &.-blue {
    border-left: 4px solid @color-special;
    border-radius: 2px;
    background-color: @color-mood-800;
  }

  &.-green {
    background-color: @color-success;
  }

  &.-red {
    background-color: @color-highlight;
  }

  &.-grey {
    background-color: @color-mood-400;
  }

  &.-mobile {
    width: 100%;
    margin: 0;
    text-align: center;
    line-height: 2.3rem;
  }
}

.status-bar__container__box {
  padding: 0 0 0 10px;
}

.status-bar__supporter-text {
  float: left;
  font-size: 2rem;
  font-weight: @font-weight-normal;
  padding-top: 10px;
  padding-right: 10px;
  text-align: right;
  @media (max-width: (@grid-min-width-lg - 1px)) {
    font-size: 1.6rem;
    padding-top: 5px;
  }
}

.status-bar__container-messagetext {
  font-size: 2rem;
  font-weight: @font-weight-light;
  line-height: 36px;
  padding-top: 10px;

  .-table-no-head & {
    padding-top: 0;
  }

  &.-multiline {
    line-height: 2.2rem;
  }

  &.-separator-line-left {
    border-left: solid 1px black;
    padding-left: 0.5em;
  }

  @media (max-width: (@grid-min-width-lg - 1px)) {
    padding-top: 5px;
    font-size: 1.6rem;
  }

  &.-mobile {
    @media (max-width: 700px) {
      line-height: 2.2rem;
    }
  }
}

.status-bar__container-headline {
  .typography(2rem, 2.6rem);
  font-weight: @font-weight-bold;
}

.status-bar__container-submessage {
  display: block;
  font-size: 1.8rem;
  font-weight: @font-weight-light;

  &.-small {
    font-size: 1.7rem;
  }
}

.status-bar__container-hideinfo {
  color: @color-mood-100;
  display: inline-block;
  font-size: 1.4rem;
  line-height: 35px;
  padding-left: 10px;
  text-decoration: underline;
  vertical-align: bottom;
}

.status-bar__container-formelemttext {
  font-size: 1.6rem;
  display: block;
  padding: 15px 10px 10px 0;
}

.status-bar__container-forminput {
  margin-right: 10px;
}

.status-bar__ar--left {
  float: left;
  font-size: 2rem;
  height: 100%;
  margin-left: 60px;
  padding-right: 10px;
  width: 38%;
}

.status-bar__ar--toptext {
  .typography(1.5rem, 2.2rem);
  font-weight: @font-weight-bold;
  margin-bottom: 0.6rem;
  text-align: center;

  @media (min-width: @grid-min-width-sm) {
    .typography(2rem, 2.6rem);
    text-align: left;
  }

  em {
    font-style: normal;
    color: @color-special;
  }
}

.status-bar__ar--messagetext {
  display: none;

  @media (min-width: @grid-min-width-sm) {
    display: block;
  }
}

.status-bar__ar--buttons {
  font-size: 1.6rem;

  @media (min-width: @grid-min-width-sm) {
    font-size: @font-size-md;
  }
}

.status-bar__ar--right {
  float: right;
  font-size: 1.5rem;
  height: 100%;
  width: 50%;
}

.status-bar__ar-success {
  font-size: 1.5rem;
  margin-bottom: 0;
  margin-top: 0;

  @media (min-width: @grid-min-width-sm) {
    font-size: @font-size-lg;
  }
}

.status-bar__ar-suceess-link {
  display: block;
  color: @color-bg;
  margin-top: 10px;
  font-size: 1.5rem;
}

.status-bar__ar--subtext {
  .typography(1.3rem, 1.6rem);
}

.status-bar_container-mobile {
  @media (min-width: 700px) {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  display: block;
}

/* grids */
.grid-status-bar {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  align-items: center;

  @media (min-width: @grid-min-width-sm) {
    flex-direction: row;
  }
}

.grid-status-bar__icon {
  align-self: flex-start;

  @media (max-width: @grid-min-width-sm - 1px) {
    display: none;
  }
}

.grid-status-bar__text {
  flex: 1;
}
